import { formatDate, formatCurrency, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Emit, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { GamingLimitDuration } from '@gig/magic-sdk/dist/adapter/responsiblegaming/setUserLimits';
import { ACCOUNT_PEP_BLOCK_QUERY } from '@gig/magic-messages';

/**
 * Provides user info including current limits, last successful login,
 * number of failed logins and user winnings or losses
 */
var UserInfoComponent = /** @class */ (function (_super) {
    __extends(UserInfoComponent, _super);
    function UserInfoComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dailyDepositLimit = 0;
        _this.weeklyDepositLimit = 0;
        _this.monthlyDepositLimit = 0;
        _this.netWinnings = 0;
        _this.lastRecordedLoginDate = null;
        _this.failedLoginAttempts = 0;
        _this.currency = null;
        _this.isLoading = true;
        return _this;
    }
    UserInfoComponent.prototype.created = function () {
        this.fetchUserInformation();
    };
    UserInfoComponent.prototype.fetchUserInformation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, isPepBlocked, stats;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = magic.session.getUser();
                        return [4 /*yield*/, window.queryBus.query(ACCOUNT_PEP_BLOCK_QUERY)];
                    case 1:
                        isPepBlocked = _a.sent();
                        if (!user || isPepBlocked) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, magic.methods.responsibleGaming.getUserPlayStatsAndLimits(12)];
                    case 2:
                        stats = _a.sent();
                        stats.limits.forEach(function (limit) {
                            switch (limit.duration) {
                                case GamingLimitDuration.ONE_DAY:
                                    _this.dailyDepositLimit = limit.amount;
                                    break;
                                case GamingLimitDuration.ONE_WEEK:
                                    _this.weeklyDepositLimit = limit.amount;
                                    break;
                                case GamingLimitDuration.ONE_MONTH:
                                    _this.monthlyDepositLimit = limit.amount;
                                    break;
                            }
                        });
                        this.netWinnings = stats.playStats.netGain - stats.playStats.netLoss;
                        this.failedLoginAttempts = user.loginTries || 0;
                        this.currency = user.currency;
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emitted when confirm button has been clicked
     */
    UserInfoComponent.prototype.onConfirm = function () {
        return;
    };
    __decorate([
        Emit('confirm'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UserInfoComponent.prototype, "onConfirm", null);
    UserInfoComponent = __decorate([
        Component({
            name: 'corex-user-info',
            filters: {
                formatDate: formatDate,
                formatCurrency: formatCurrency,
            },
        })
    ], UserInfoComponent);
    return UserInfoComponent;
}(Mixins(MagicConfigMixin)));

export default UserInfoComponent;
